import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_PURCHASE_ORDER_KEY } from '@/keys';

type CreatePurchaseOrderCommentPayload = {
  purchaseOrderId: string;
  value: string;
};

const createPurchaseOrderComment = async ({
  purchaseOrderId,
  value,
}: CreatePurchaseOrderCommentPayload): Promise<void> => {
  await api.post('/purchase-order-comments', {
    purchaseOrderId,
    value,
  });
};

export function useCreatePurchaseOrderComment(
  purchaseOrderId: string,
): UseMutationResult<void, Error, CreatePurchaseOrderCommentPayload> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => createPurchaseOrderComment(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [...GET_PURCHASE_ORDER_KEY, purchaseOrderId],
      });
    },
  });
}
